export const AppActions = {
    SELECTED_TURN_SYMBOL : 'SELECTED_TURN_SYMBOL',
    CLEAR_GAME_GRID : 'CLEAR_GAME_GRID',
    UPDATE_GRID : 'UPDATE_GRID',
    START_GAME : 'START_GAME',
    END_GAME : 'END_GAME'
}